<template>
  <el-row>
    <el-col :span="24">
      <div class="header login">
        <div class="container login">
          <el-col  :span="12" :xs="13" :offset="1"   class="login-header-col">
            <img :src="$config.FILE_URL+oemCompany.logo" class="login-header-logo"/>
            <strong class="hidden-xs-only login-header-title">
              {{ lang == 'zh' ? oemCompany.systemName&&oemCompany.systemName['zh-cn']:oemCompany.systemName&&oemCompany.systemName[lang]}}
            </strong>
          </el-col>
  
          <el-col :span='12' :xs="10" class="ogin-header-right" :offset="3">
            <el-col :span='17' class="hidden-sm-and-down login-header-col login-header-link" :class="{marginRight:oemCompany.lang&&oemCompany.lang.length<2 }" v-if="homePage[0]" >
              <div>
              <el-link :underline="false" v-for="(item,key) in homePage" :href="item[Object.keys(item)[0]]" :key="key">{{Object.keys(item)[0]}}</el-link>
              </div>
            </el-col>
            <el-col :span='6' :xs="14"  class="login-header-col login-center" v-if="oemCompany.lang&&oemCompany.lang.length>1">
              <span>
                <a v-bind:class="lang !== 'en' ? 'noactive' : ''" @click="changeLang('en')" title="ENGLISH">EN</a>
                &nbsp;&nbsp;
                <a v-bind:class="lang !== 'zh' ? 'noactive' : ''" @click="changeLang('zh')" title="中文">中文</a>
              </span>
            </el-col>
            <el-col :span="6" class="hidden-md-and-up login-header-col " v-if="homePage[0]">
              <div class="hidden-md-and-up"  :style="{margin: '0 auto'}">
                  <i class="el-icon-s-fold" @click="drawer = true" v-show="drawer===false"></i>
                  <i class="el-icon-s-unfold"  v-show="drawer===true"></i>
              </div>
            </el-col>
          </el-col>
    
          <div class="clear"></div>
          <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            :before-close="handleClose">
            <div class="drawer-link">
            <div class="item" v-for="(item,key) in homePage"  :key="key"> 
                 <el-link type='default' :underline="false" :href="item[Object.keys(item)[0]]">{{Object.keys(item)[0]}}</el-link>
              </div>
            </div>
          </el-drawer>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  export default{
    name: 'Header',
    data() {
      return {
        toggleMobileNav: true,
        login:this.$t('LOGIN'),
        drawer: false,
        direction: 'rtl',
        DOMAIN: document.domain.substring(document.domain.indexOf('.') + 1),
      };
    },
    computed: {
      ...mapState(['lang', 'session', 'oemCompany']),
      ...mapGetters(['isAdmin', 'isInfo', 'hasPermission', 'isMasterAccount']),
      homePage(){
          if (this.oemCompany.other) {
            let other =  JSON.parse(this.oemCompany.other)
            if(other.navigationBar){
            let navigationBar = other.navigationBar.filter(item => item.homePage)
            return navigationBar[0] ? navigationBar[0].homePage : []
            }else{
              return []
            }
          }else{
            return []
          }
        }
    },
    methods: {
      handleClose(done) {
         done();
      },
      isCurrentRoute(route){
        return this.$route.name==route;
      },
      looseEqualRoute(route){
        console.log(route,this.$route);
        if(!this.$route.name)return;
        if(Array.isArray(route)){
          return route.find(item=>this.$route.name.includes(item));
        }
        return this.$route.name.includes(route);
      },
      signout() {
        // this.$apiService.post('/user/signout').then(result => {
        //   this.$router.push({name:'login'});
        // });
        this.$apiService.post('/user/sso/logout').then(result => {
          this.$router.push({name:'login'});
          this.$cookies.remove("user");
          this.$cookies.remove("oemToken", '/',this.DOMAIN);
          this.$cookies.remove("ts-token");
        });
      },
      changeLang: function (currentLang) {
        this.$i18n.locale = currentLang;
        this.$store.commit('setLang', currentLang);
        //title
        var curlang = currentLang == 'zh' ? 'zh-cn': currentLang
        document.title = this.$store.state.oemCompany.systemName[curlang] || '';
      }
    },
    mounted() {
      function isMobile() {
        return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      }

      if (isMobile()) {
        this.toggleMobileNav = false;
      } else {
        this.toggleMobileNav = true;
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.marginRight{
  margin-right: 60px;
}
  .drawer-link{
    display: flex;
    flex-direction: column;
  }
  .ogin-header-right{
    display: flex;
    justify-content: flex-end;
  }
  .el-drawer .item {
    margin-bottom: 20px;
  }
  .noactive {
    color: #939393;
  }
  strong{
    font-size: 20px;
  }
  .login-header-col{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 70px;
  }
  .login-header-link{
    display: flex;
    justify-content: flex-end;
  }
  .el-link {
    font-size: 14px;
    font-weight: bold;
    margin-left: 10px;
    color: #333 !important;
  }

  .login-center{
    justify-content: center;
  }
  .login-header-logo {
    height: 60px;
  }
  .login-header-title{
    margin-left: 20px;
  }
  div.login-header-col{
    max-width: 1200px;
  }
  .header-items-container{
    display: flex;
    margin-left: 100px;
    width: calc(100% - 186px);
  }
  div.container.login{
    /*background: #262626;*/
    display: flex;
    /* justify-content: center; */
  }
  .header-item{
    color: #fff;
    font-size: 18px;
    text-align: center;
  }
  .header-item>a{
    padding: 8px 15px;
    border-radius: 3px;
  }
  .header-item>a:hover{
    background-color: #D08D29;
    border: 1px solid #D08D29;
  }
  .header-item>a,.header-item>a:active{
    color: #fff;
  }
  @media (max-width: 768px) {
    div.header-item{
      font-size: 14px;
    }
    div.header-item>a{
      padding: 5px;
      border-radius: 3px;
    }
    .grid-content{
      display: none;
    }
    div.header-items-container{
      justify-content: space-around;
      position: absolute;
      bottom: 14px;
      width: 100%;
      margin-left: 0;
    }
    div.header.login{
      background: #262626;
    }
    .header-language{
      position: absolute;
      top: 59px;
      right: 0px;
      justify-content: flex-end;
    }
    div.header-role{
      padding: 0px;
    }
    .header-role div.el-dropdown{
      margin-right: 5px;
    }
  }
  div.container{
    width: 100%;
    padding: 0px;
    background: #fff;
    color: rgb(51,51,51);
  }

  .header-role{
    padding:12px;
    float: left;
  }

  @media (max-width:1280px ) {
    .container{
      width: 84%;
    }
    div.bg-purple-white .so-normal,div.bg-purple-white .el-dropdown{
      margin-right: 8px;
      height: 30px;
      line-height: 30px;
    }
  }

  div.header .el-button{
    border-color: #337ab7;
    background-image: none;
  }

  .header-role span{
    float:right;
    margin-right:9px;
    margin-left:10px;
  }
  .header-language-font{
    float: left;
    width: auto;
    display: inline;
  }
  .font-color-yellow{
    color:yellow;
  }
  .mobile_button{
    float:right;
    margin-top:10px;
  }
  .mobile_button i.fa{
    font-size: 23px;
  }
  .icon-medal:after ,
  .navbar-fa-shield-pro:after,
  .icon-medal.bronze:after,
  .icon-medal.silver.light:after,
  .badge-global:after,
  .badge-global-plus:after,
  .badge-global-luxury:after{
    font-family: Roboto,"Helvetica Neue",Helvetica,Arial,sans-serif;
    text-transform: uppercase;
    font-weight: 700;
    padding-left: 3px;
  }
  .header-role i.navbar-fa-shield-pro {
    color: #b4d5e6;
  }
  .navbar-fa-shield-pro:after {
    content: "pro";
  }
  .icon-medal.bronze {
    color: #b1875b;
  }
  .icon-medal.bronze:after{
    content: "bronze";
  }

  .icon-medal.silver.light {
    color: #606266;
  }
  .icon-medal.silver.light:after{
    content: "silver";
  }
  .icon-medal.gold {
    color: #fac33c;
  }
  .icon-medal.gold:after {
    content: 'gold';
  }
  .badge-global {
    color: #fac33c;
  }
  .badge-global:after{
    content: 'global';
  }
  .badge-global-plus {
    color: #fac33c;
  }
  .badge-global-plus:after{
    content: 'plus';
  }
  .badge-global-luxury {
    color: #fac33c;
  }
  .badge-global-luxury:after{
    content: 'luxury';
  }
  .badge-global-deluxe {
    color: #fac33c;
  }
  .badge-global-deluxe:after{
    content: 'deluxe';
  }
  .el-menu--horizontal i.fa{
    color:#fff;
    margin-right:5px;
  }
  .header-language-font span:hover{
    color:#fff;
  }
  .header .header-language .header-language-font button.active,
  .header .header-language .header-language-font button.active span,
  .header .header-language .header-language-font button.el-button:hover {
    color:rgb(51,51,51);
  }

  div.header .header-language .el-button{
    margin-top:0 ;
    font-size: 13px;
  }
  .el-menu--horizontal>.el-menu-item{
    color:#fff;
  }
  .el-menu--horizontal>.el-menu i{
    color: #333;
  }
  .so-active{
    box-shadow: 0 0 0;
    font-weight: 600;
    font-size: 15px;
  }
  .so-active >div>a{
    color:#fff;
  }

  .header-role .el-menu,
  .header-role .el-menu:hover{
    background: #252531;    color: #fff;
  }
  .so-normal span,.so-normal span a,.so-top span{
    cursor: pointer;
    color: rgb(51,51,51);
  }
  div.so-normal,li.so-normal,div.el-dropdown {
    list-style-type: none;
    float: left;
    height: 30px;
    line-height: 30px;
    margin-right: 20px;
  }

  div li.so-normal a{
    cursor: pointer;
    color: rgb(51,51,51);
  }

  .bg-purple-white .el-dropdown{
    padding: 0px 8px;
    margin-right: 16px;
  }

  .el-dropdown-menu__item a{
    color:#333;
  }

  .so-top .font-color-yellow{
    color: yellow;
  }
  .el-dropdown-link-div{
    font-size: 12px;
    color: rgb(51,51,51);
  }
  .el-dropdown-link-div i{
    font-size: 12px;
  }

  .header-language{
    display: flex;
    align-items: center;
    min-width: 260px;
  }
</style>




// WEBPACK FOOTER //
// src/components/LoginHeader.vue